import { variant } from 'styled-system';

export const kind = variant({
  prop: 'kind',
  variants: {
    'item-1': {
      color: 'navLinkItem1TextColor',
      fontWeight: 'navLinkItem1FontWeight',
      borderWidth: 'navLinkItem1BorderWidth',
      borderBottomWidth: 'navLinkItem1BorderBottomWidth',
      borderBottomColor: 'navLinkItem1BorderBottomColor',
      borderStyle: 'solid',
      '&:hover': {
        color: 'navLinkItem1TextColor',
        borderBottomColor: 'navLinkItem1HoverBorderBottomColor',
      },
      '&:active': {
        color: 'navLinkItem1TextColor',
        borderBottomColor: 'navLinkItem1ActiveBorderBottomColor',
      },
      '&[aria-current]:not([aria-current="false"]):not([aria-current=""])': {
        color: 'navLinkItem1SelectedTextColor',
        fontWeight: 'navLinkItem1SelectedFontWeight',
        borderBottomColor: 'navLinkItem1SelectedBorderBottomColor',
        '&:hover': {
          color: 'navLinkItem1SelectedTextColor',
          borderBottomColor: 'navLinkItem1SelectedBorderBottomColor',
        },
        '&:active': {
          color: 'navLinkItem1SelectedTextColor',
          borderBottomColor: 'navLinkItem1SelectedBorderBottomColor',
        },
      },
    },
    'item-2': {
      color: 'navLinkItem2TextColor',
      fontWeight: 'navLinkItem2FontWeight',
      borderWidth: 'navLinkItem2BorderWidth',
      borderBottomWidth: 'navLinkItem2BorderBottomWidth',
      borderBottomColor: 'navLinkItem2BorderBottomColor',
      borderStyle: 'solid',
      '&:hover': {
        color: 'navLinkItem2TextColor',
        borderBottomColor: 'navLinkItem2HoverBorderBottomColor',
      },
      '&:active': {
        color: 'navLinkItem2TextColor',
        borderBottomColor: 'navLinkItem2ActiveBorderBottomColor',
      },
      '&[aria-current]:not([aria-current="false"]):not([aria-current=""])': {
        color: 'navLinkItem2SelectedTextColor',
        fontWeight: 'navLinkItem2SelectedFontWeight',
        borderBottomColor: 'navLinkItem2SelectedBorderBottomColor',
        '&:hover': {
          color: 'navLinkItem2SelectedTextColor',
          borderBottomColor: 'navLinkItem2SelectedBorderBottomColor',
        },
        '&:active': {
          color: 'navLinkItem2SelectedTextColor',
          borderBottomColor: 'navLinkItem2SelectedBorderBottomColor',
        },
      },
    },
    'item-3': {
      color: 'navLinkItem3TextColor',
      fontWeight: 'navLinkItem3FontWeight',
      borderWidth: 'navLinkItem3BorderWidth',
      borderBottomWidth: 'navLinkItem3BorderBottomWidth',
      borderBottomColor: 'navLinkItem3BorderBottomColor',
      borderStyle: 'solid',
      '&:hover': {
        color: 'navLinkItem3TextColor',
        borderBottomColor: 'navLinkItem3HoverBorderBottomColor',
      },
      '&:active': {
        color: 'navLinkItem3TextColor',
        borderBottomColor: 'navLinkItem3ActiveBorderBottomColor',
      },
      '&[aria-current]:not([aria-current="false"]):not([aria-current=""])': {
        color: 'navLinkItem3SelectedTextColor',
        fontWeight: 'navLinkItem3SelectedFontWeight',
        borderBottomColor: 'navLinkItem3SelectedBorderBottomColor',
        '&:hover': {
          color: 'navLinkItem3SelectedTextColor',
          borderBottomColor: 'navLinkItem3SelectedBorderBottomColor',
        },
        '&:active': {
          color: 'navLinkItem3SelectedTextColor',
          borderBottomColor: 'navLinkItem3SelectedBorderBottomColor',
        },
      },
    },
  },
});

export const vertSize = variant({
  prop: 'vertSize',
  variants: {
    'size-1': {
      pt: 'navLinkSize1PaddingTop',
      px: 'navLinkSize1PaddingX',
      pb: 'navLinkSize1PaddingBottom',
      fontSize: 'navLinkSize1FontSize',
      lineHeight: 'navLinkSize1LineHeight',
      minHeight: 'navLinkSize1MinHeight',
      '& svg': {
        width: 'navLinkSize1IconSize',
        height: 'navLinkSize1IconSize',
      },
    },
    'size-2': {
      pt: 'navLinkSize2PaddingTop',
      px: 'navLinkSize2PaddingX',
      pb: 'navLinkSize2PaddingBottom',
      fontSize: 'navLinkSize2FontSize',
      lineHeight: 'navLinkSize2LineHeight',
      minHeight: 'navLinkSize2MinHeight',
      '& svg': {
        width: 'navLinkSize2IconSize',
        height: 'navLinkSize2IconSize',
      },
    },
  },
});

export type Kind = 'item-1' | 'item-2' | 'item-3';
export type VertSize = 'size-1' | 'size-2';
